import { request } from '@/utils/request'
import { createDownloadFromResponse } from '@/utils/download'
const API ={
  queryAllMenu: '/permission/queryAllMenu',
  login: '/public/login',
  modifyPassword: '/user/resetPwd',
  getDicListByTypeKey: '/sys/dictionary/getDicListByTypeKey',
  doDownloadTemp: '/common/downLoadTemp',
  upload: '/common/upload',
  getFileAttribute: '/common/getFileAttribute',
  editFile: '/common/editFile',
  deleteFile: '/common/del',
  getUserOrgs: '/common/getUserOrgs',
  getMsg: '/common/getMsg',
  modifyDelFileInfo:'/common/modifyDelFileInfo', //调整业务,删除-撤回整条附件信息
  modifyDelFile:'/common/modifyDelFile', //调整业务,删除-撤回某条附件下对应的个别附件 
}
// 用户相关API
export const userApi = {
  login(params) {
    return request.post(API.login, params, {
      headers: { 'Content-Type': 'application/json' }
    })
  },
  modifyPassword(params) {
    return request.post(API.modifyPassword, params)
  },
  
  // 退出登录
  logout() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ code: 200, message: '退出成功' })
      }, 500)
    })
  },
  getDicListByTypeKey(typeKey) {
    return request.post(API.getDicListByTypeKey, { typeKey }).then(res => {
      if (res.code === 200) {
        return { code: 200, data: res.data }
      }
      return res
    })
  },
  
  getFileAttribute(params) {
    return request.post(API.getFileAttribute, params).then(res => {
      return res
    })
  },
  getUserOrgs(params) {
    return request.post(API.getUserOrgs, params).then(res => {
      return res
    })
  },
  
}

// 菜单相关API
export const menuApi = {
  getMenuData() {
    return request.post(API.queryAllMenu).then(res => {
      if (res.code === 200) {
        return { code: 200, data: res.data.jz || [] }
      }
      return res
    })
  }
}

/** 公共上传 fileType 枚举（与接口文档一致） */
export const UPLOAD_FILE_TYPE = {
  OTHER: 'other',               // 其他文件
  LOADING_PROCESS: 'loadingProcess', // 装货过程
  ORDER_ERROR: 'orderError',     // 订单异常
  DELIVERY_RECEIPT: 'deliveryReceipt', // 签收单
  SETTLEMENT: 'settlement'       // 结算凭证
}

// 公共接口
export const commonApi = {
  getMsg(params) {
    return request.post(API.getMsg, params).then(res => {
      return res
    })
  },
  /** 直接传 FormData，兼容已有调用 */
  upload(formData) {
    return request.post(API.upload, formData).then(res => {
      return res
    })
  },
  /**
   * 公共上传文件（按 /common/upload 接口文档封装）
   * @param {Object} options
   * @param {File} options.file - 上传文件（必填）
   * @param {string} [options.fileType] - 文件类型：other | loadingProcess | orderError | deliveryReceipt | settlement
   * @param {number|string} [options.parentId=0] - 单据ID，没有单据时传 0
   * @param {number|string} [options.childId=0] - 子明细ID，没有单据时传 0
   * @returns {Promise<{code, data, ...}>} 接口返回，data 一般为路径或文件信息（以实际接口为准）
   */
  uploadFile(options = {}) {
    const { file, fileType, parentId = 0, childId = 0 } = options
    if (!file || !(file instanceof File)) {
      return Promise.reject(new Error('请传入有效的 File 对象'))
    }
    const formData = new FormData()
    formData.append('file', file)
    formData.append('parentId', String(parentId))
    formData.append('childId', String(childId))
    if (fileType != null && fileType !== '') {
      formData.append('fileType', String(fileType))
    }
    return request.post(API.upload, formData).then(res => {
      return res
    })
  },
  // 按字典key（POST/POST_W）以 form-data 方式获取字典
  getDicListByKeyForm(key) {
    const formData = new FormData()
    formData.append('key', key)
    return request.post(API.getDicListByTypeKey, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => {
      if (res.code === 200) {
        return { code: 200, data: res.data }
      }
      return res
    })
  },  
  // 下载模板文件
  doDownloadTemp(params) {
    return request.post(API.doDownloadTemp, params, {
      responseType: 'blob', // 重要：设置响应类型为blob以处理文件下载
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      // 根据模板类型设置文件名
      const fileName = params.get('lx') === 'product' ? '产品导入模板.xlsx' : ''
      
      // 使用工具函数创建下载
      createDownloadFromResponse(res, fileName)
    }).catch(error => {
    })
  },
  editFile(params) {
    // 将普通对象转换为FormData格式
    const formData = new FormData()
    
    // 添加顶级字段
    if (params.projectId) formData.append('projectId', params.projectId)
    if (params.projectid) formData.append('projectId', params.projectid)
    if (params.isModify) formData.append('isModify', params.isModify)
    if (params.dateStr) formData.append('dateStr', params.dateStr)
    
    // 添加info数组字段 - 使用 info[0].name 格式
    if (params.info && Array.isArray(params.info)) {
      params.info.forEach((item, index) => {
        Object.keys(item).forEach(key => {
          const value = item[key]
          // 如果值是数组，添加多个同名参数
          if (Array.isArray(value)) {
            value.forEach(v => {
              formData.append(`info[${index}].${key}`, v)
            })
          } else {
            formData.append(`info[${index}].${key}`, value)
          }
        })
      })
    }
    
    return request.post(API.editFile, formData).then(res => {
      return res
    })
  },
  deleteFile(params) {
    return request.post(API.deleteFile, params).then(res => {
      return res
    })
  },
  //调整业务,删除-撤回整条附件信息
  modifyDelFileInfo(params) {
    return request.post(API.modifyDelFileInfo, params).then(res => {
      return res
    })
  },
  //调整业务,删除-撤回某条附件下对应的个别附件 
  modifyDelFile(params) {
    return request.post(API.modifyDelFile, params).then(res => {
      return res
    })
  }
}

// 导出所有API
export default {
  userApi,
  menuApi,
  commonApi,
}
